// extracted by css-extract-rspack-plugin
export default {"wrapper":"_6e93cc7c"};